Ext.define('SA.VectorMapModelState', {
    singleton: true,

    get(model) {
        return {
            attributes: this.getAttributesState(model),
            businessSearch: model.getBusinessSearch(),
            country: model.getCountry(),
            extent: model.getExtent(),
            filter: model.getFilterObject(),
            geographicRelease: model.getGeographicRelease(),
            geoUnits: this.getGeoUnitsState(model),
            hasLackOfDataVariation: model.hasLackOfDataVariation(),
            hasUserAttributeWithoutUnitsAtCurrentScale: model.hasUserAttributeWithoutUnitsAtCurrentScale(),
            infoLocation: model.getInfoLocation(),
            isLocationHighlightEnabled: model.isHighlightLocation(),
            isLocationLabelsEnabled: model.hasLabels(),
            isLocationMaskEnabled: model.hasLocationMask(),
            legendBreaks: model.getLegendBreaks(),
            legendSettings: model.getLegendSettings(),
            locations: this.getLocationsState(model),
            maxExtent: model.getMaxExtent()
        };
    },

    getAttributesState(model) {
        var selected = model.getAttribute(),
            supported = model.getSupportedProjectAttributes();

        return {selected, supported};
    },

    getGeoUnitsState(model) {
        var auto = model.findAutoGeographicUnit(),
            isAutoSelect = model.isAutoSelectGeoUnit(),
            selected = model.getGeographicUnit(),
            supportedDiscoverable = model.getAllowedGeographicUnits();

        return {auto, isAutoSelect, selected, supportedDiscoverable};
    },

    getLocationsState(model) {
        var selected = model.getLocation(),
            supported = model.getSupportedProjectLocations();

        return {selected, supported};
    }
});